import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=0dda4c2a&scoped=true&"
import script from "./register-success.vue?vue&type=script&lang=js&"
export * from "./register-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda4c2a",
  null
  
)

export default component.exports